import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';

export const SCHEDULE_LOCK_REQUEST = 'SCHEDULE_LOCK_REQUEST';
export const SCHEDULE_LOCK_SUCCESS = 'SCHEDULE_LOCK_SUCCESS';
export const SCHEDULE_LOCK_FAILURE = 'SCHEDULE_LOCK_FAILURE';

export const SCHEDULE_UNLOCK_REQUEST = 'SCHEDULE_UNLOCK_REQUEST';
export const SCHEDULE_UNLOCK_SUCCESS = 'SCHEDULE_UNLOCK_SUCCESS';
export const SCHEDULE_UNLOCK_FAILURE = 'SCHEDULE_UNLOCK_FAILURE';

export const lockSchedule = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_LOCK_REQUEST });
    return axios(apiRequestOptions(apiPath.SCHEDULE.LOCK, null, { params: { id: competitionId } }))
      .then(transformHttpResponse)
      .then(response => dispatch({ type: SCHEDULE_LOCK_SUCCESS, data: response.data }))
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_LOCK_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};

export const unlockSchedule = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_UNLOCK_REQUEST });
    return axios(apiRequestOptions(apiPath.SCHEDULE.UNLOCK, null, { params: { id: competitionId } }))
      .then(transformHttpResponse)
      .then(response => dispatch({ type: SCHEDULE_UNLOCK_SUCCESS, data: response.data }))
      .catch(error => transformHttpResponse(error.response))
      .catch(error => {
        dispatch({ type: SCHEDULE_UNLOCK_FAILURE, error });
        dispatch(errorRequestHandler(error));
      });
  };
};
